import React from 'react';
import { NavLink } from 'react-router-dom';
import CTAButton from '../buttons/CTAButton';
import SecondaryButton from '../buttons/SecondaryButton';

const navigation = [
        {
                heading: 'Platform',
                links: [
                        { label: 'Kinn Overview', to: '/' },
                        { label: 'Seller Dashboard', to: '/seller/dashboard' },
                        { label: 'Pricing & Plans', to: '/subscription' },
                        { label: 'Compliance & FHRS', to: '/seller/get-started' },
                ],
        },
	{
		heading: 'Company',
		links: [
			{ label: 'Our Mission', to: '/our-mission' },
			{ label: 'Founding Sellers', to: '/founding-sellers' },
			{ label: 'Help Centre', to: '/help' },
		],
	},
	{
		heading: 'Legal',
		links: [
			{ label: 'Privacy Policy', to: '/privacy' },
			{ label: 'Terms & Conditions', to: '/terms' },
			{ label: 'Accessibility', to: '/help' },
			{ label: 'Contact', to: 'mailto:hello@kinn.menu' },
		],
	},
];

const Footer = () => {
	return (
		<footer className="relative mt-24 w-full">
			<div className="mx-auto w-full max-w-6xl px-6 pb-16 sm:px-8">
                                <div className="relative overflow-hidden rounded-[32px] border border-[color:var(--shell-border)] bg-[color:var(--shell-card)]/95 px-8 py-12 shadow-[var(--shadow-soft)] backdrop-blur-xl sm:px-12">
					<div className="relative z-[1] grid gap-12 lg:grid-cols-[1.2fr_0.8fr]">
						<div>
							<div className="flex items-center gap-4">
								<div className="relative h-14 w-14 rounded-2xl bg-gradient-to-br from-[#C2E9FB] to-[#A1C4FD] shadow-lg shadow-blue-200/40 ring-1 ring-white/40">
									<img
										src="/logo/icon.svg"
										alt="Kinn logo"
										className="absolute inset-0 h-full w-full rounded-2xl object-cover"
									/>
								</div>
                                                                <div className="leading-tight">
                                                                        <span className="block text-lg font-semibold tracking-wide text-text-primary">
                                                                                Kinn
                                                                        </span>
                                                                        <span className="block text-xs uppercase tracking-[0.3em] text-brand-slate">
                                                                                Nourish • Create • Connect
                                                                        </span>
                                                                </div>
                                                        </div>
                                                        <p className="mt-6 max-w-md text-base text-text-primary/80">
                                                                A calm, intelligent home for every food innovation. Build trust, automate compliance, and
                                                                share your craft with communities that care.
                                                        </p>
							<div className="mt-8 flex flex-wrap gap-4">
								<CTAButton size="md" className="px-7" as={NavLink} to="/seller/get-started">
									Become a Seller
								</CTAButton>
								<SecondaryButton
									size="md"
									className="border-brand-stone/70 text-[var(--color-text-primary)] hover:bg-white/70"
									as={NavLink}
									to="/search"
								>
									Explore Menus
								</SecondaryButton>
							</div>
						</div>

						<div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
							{navigation.map((section) => (
								<div key={section.heading}>
									<h3 className="text-xs uppercase tracking-[0.35em] text-brand-slate">
										{section.heading}
									</h3>
                                                                        <ul className="mt-4 space-y-3 text-sm text-text-primary/80">
										{section.links.map((link) => (
											<li key={link.label}>
												{link.to.startsWith('mailto:') ? (
													<a
														href={link.to}
                                                                                                                className="transition-colors duration-200 hover:text-text-primary"
													>
														{link.label}
													</a>
												) : (
													<NavLink
														to={link.to}
                                                                                                                className="transition-colors duration-200 hover:text-text-primary"
													>
														{link.label}
													</NavLink>
												)}
											</li>
										))}
									</ul>
								</div>
							))}
						</div>
					</div>

                                        <div className="mt-12 flex flex-col gap-4 border-t border-white/40 pt-6 text-sm text-text-primary/60 md:flex-row md:items-center md:justify-between">
						<span>© {new Date().getFullYear()} Quenra Ltd® All rights reserved.</span>
						<div className="flex flex-wrap gap-4">
                                                        <NavLink to="/privacy" className="hover:text-text-primary">
								Privacy
							</NavLink>
                                                        <NavLink to="/terms" className="hover:text-text-primary">
								Terms
							</NavLink>
                                                        <a href="mailto:hello@kinn.menu" className="hover:text-text-primary">
                                                                Contact
                                                        </a>
						</div>
					</div>

					<div className="pointer-events-none absolute inset-0 -z-[1] rounded-[32px] bg-gradient-to-b from-white/40 via-transparent to-white/10" />
				</div>
			</div>
		</footer>
	);
};

export default Footer;
